<ng-container *ngIf="!ignoreMonitoringService">
    <div class="has-border-top margin-bottom-1">MAC Address - {{ macAddress$ | async }}</div>
    <clare-monitoring-services-form
        [isProjectOnline]="isProjectOnline"
        [alulaDealerId]="alulaDealerId"
        [dbSecurityDevice]="dbSecurityDevice"
        [project]="project"
        [isClareOne]="isClareOne"
        [clareOneCallerIdNumber]="clareOneCallerIdNumber$ | async"
        [entity]="entity"
        [alulaDealer]="alulaDealer$ | async"
        [shouldShowSpinnerOnSubmit]="true"
        [isReplacePanelStep]="true"
        [saveButtonText]="'Enable Monitoring Services'"
        [receiverGroupSource$]="receiverGroupSource$"
        [alulaDevice$]="alulaDevice$"
        [defaultDevice]="defaultDevice"
        (onFormCompleted)="onFormCompleted($event)"
    >
    </clare-monitoring-services-form>
</ng-container>
